import {useEffect, useState} from 'react';
import {getUserRates, setUserRate} from "../../api/Api";
import {Table} from "antd";
import {MoneyEntryWidget} from "../sales/MoneyEntryWidget";

export const LaborRate = ({refresh, onRefresh, onApiFail, props}) => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        getUserRates().then(us => {
            if (us !== undefined) {
                us.forEach(u => {
                    u.key = u.id;
                    u.hourRate = parseFloat(u.hourRate)
                });
                console.log(JSON.stringify(us));
                setUsers(us);
            } else {
                setUsers([]);
            }
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail]);

    const onRateChange = (user) => (value) => {
        setUserRate(user.id, value).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const getFullName = (record) => {
        return `${record.firstname} ${record.lastname}`;
    }

    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Name',
            dataIndex: 'firstname',
            key: 'firstname',
            render: (val, record) => {
                return getFullName(record)
            }
        },
        {
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
        },
        {
            title: 'Rate',
            dataIndex: 'hourRate',
            key: 'hourRate',
            render: (val, record, index) => {
                // return `$ ${val}`;
                return <MoneyEntryWidget title={`Hourly Rate for ${getFullName(record)}`} onPriceChange={onRateChange(record)} value={val} placeholder={`Rate`} />
            }
        }
    ];

    return <div style={{textAlign:'left'}}>
        <div style={{color: "#108ee9"}}>Set Staff Hourly Rates.  Used in COGs, for example Fulfillment.</div>
        <Table dataSource={users} columns={columns} pagination={false} />
    </div>

}